import { Component, Input, OnInit } from '@angular/core';
import _ from 'lodash';
import { CustomChartConfiguration, ChartData, Color } from '../../types/ng-charts.type';
import {
  chartConfigurations,
  chartCanvasNumericConfiguration
} from '../../configurations/simple-charts';
import { ChartConfiguration, ChartType } from 'chart.js';

@Component({
  selector: 'app-chart-canvas',
  templateUrl: './chart-canvas.component.html',
  standalone: false
})
export class ChartCanvasComponent {
  private _chartData: ChartData;
  chartConfiguration: CustomChartConfiguration;
  chartHeight = chartCanvasNumericConfiguration['BASE_HEIGHT'];
  data: ChartConfiguration['data'] = {
    labels: [],
    datasets: [{ data: [] }]
  };
  constructor() {}

  get chartData(): ChartData {
    return this._chartData;
  }

  get chartType(): ChartType {
    return this.chartConfiguration.chartType as ChartType;
  }

  @Input() customColors: Color = { backgroundColor: [] };

  /**
   * Setter method for chart data
   * We want to have it this way because we need to manipulate the chart configuration along
   * with the data being sent by the component using this component
   * @param data: includes chart type, selected data point, and dataset with aggregation
   */
  @Input() set chartData(data: ChartData) {
    this._chartData = data;
    this.chartConfiguration = _.cloneDeep(chartConfigurations[data.chartType]);
    this.chartHeight =
      this._chartData.dataset.categories.length <=
      chartCanvasNumericConfiguration['BASE_NUMBER_OF_CATEGORIES']
        ? chartCanvasNumericConfiguration['BASE_HEIGHT']
        : (this._chartData.dataset.categories.length -
            chartCanvasNumericConfiguration['BASE_NUMBER_OF_CATEGORIES']) *
            chartCanvasNumericConfiguration['INCREMENT_PER_CATEGORY'] +
          chartCanvasNumericConfiguration['BASE_HEIGHT'];
    if (this.chartConfiguration.chartType === 'bar') {
      const scaleProperty = this.chartConfiguration.options.indexAxis === 'y' ? 'x' : 'y';
      this.chartConfiguration.options.scales[scaleProperty].ticks.stepSize =
        Math.max(...data.dataset.values) >
        chartCanvasNumericConfiguration['MAX_NUMBER_FOR_CUSTOM_TICKS']
          ? Math.ceil(
              Math.max(...data.dataset.values) / chartCanvasNumericConfiguration['NUMBER_OF_TICKS']
            )
          : 1;
      this.chartConfiguration.options.scales[scaleProperty].suggestedMax =
        Math.max(...data.dataset.values) + 1;
    }

    this.data.datasets = [
      {
        data: this.chartData.dataset.values,
        backgroundColor: this.chartConfiguration.color.backgroundColor
      }
    ];
    this.data.labels = this.chartData.dataset.categories;
  }
}
